

































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import WidgetService from '@/services/widget.service';
import {MarkerClusterer} from '@googlemaps/markerclusterer';
import {rssiColor, snrColor, spreadingFactorColor} from '@/helpers/lorawan.network';
import {Project} from '@/types';
import {GlobalTokenManager} from '@/classes/axios.cancel.token';
import VueApexCharts from 'vue-apexcharts';
import { MarkerFactory, SPREADING_FACTOR_COLORS } from '@/helpers/mapmarker.helper';

@Component({
  components: {
    VueApexCharts,
    SvgIcon: {
      props: ['svg'],
      render(h: any): any {
        return h('div', { domProps: { innerHTML: (this as any).svg } });
      },
    },
  },
})
export default class AdvancedMarkerMap extends Vue {
  @Action private changeProjectAsync: any;
  @Action private changeOrganisationAsync: any;
  @Action private addToastErrorMessage: any;

  @Getter private hasPermission!: any;
  @Getter private activeOrganisation: any;

  @Prop({ default: '100vh' }) private height!: string;
  @Prop({ default: true }) private showLegends!: boolean;

  private uiDisabled: boolean = false;
  private hasGatewaySettings: boolean = false;
  private readonly DEFAULT_ZOOM = 3;

  private map: any;
  private AdvancedMarkerElement: any;
  private allDeviceMarkers: Array<any & { locationData?: any[] }> = [];
  private gatewayMarkers: { [key: string]: any } = {};
  private markerClusterer: any | null = null;

  private deviceLocations: any[] = [];
  private gatewayLocations: any[] = [];
  private locations: any[] = [];
  private allMarkers: any[] = [];

  private historyVisible: boolean = false;
  private historyDays: string[] = [];
  private timelineLoading: boolean = false;
  private chartsLoading: boolean = false;
  private dayWidth: number = 300 + 2;
  private timelineKey: number = 0;

  private orgFilter: number | null = null;
  private projectFilter: number | null = null;
  private visibleMarkers: string[] = ['devices', 'gateways'];
  private statusFilters: string[] = ['active', 'fault', 'inactive'];
  private projects: any = [];
  private allOrgs: any = [];
  private allProjects: any = [];
  private loadingProjects = false;

  private equipmentFilters: any[] = [];
  private filterMarkerClicked: boolean = false;
  private isLoaded: boolean = false;

  private chartsExpanded: boolean = false;

  private unfilteredSelectedLocations: any[] = [];
  private selectedLocations: any[] = [];
  private activePanel: number | null = 0;
  private drawerVisible: boolean = false;
  private selectedMarker: any | null = null;
  private layersLoading: boolean = false;
  private layerUpdateTimeout: number | null = null;
  private mapLoading: boolean = true;
  private loadingDetails: boolean = false;
  private loadingConnectionDetails: boolean = false;

  private deviceSvg: string = '';
  private gatewaySvg: string = '';
  private activeSvg: string = '';
  private faultSvg: string = '';

  private autoRefreshEnabled: boolean = false;
  private refreshInterval: number | null = null;
  private refreshDialOpen: boolean = false;

  private activePolylines: any[] = [];
  private ghostMarkers: any[] = [];

  private globalSearchQuery: string | null = null;
  private searchDebounce: number | null = null;

  private selectedSearchItem: any = null;
  private combinedSearchResults: any[] = [];
  private searchLoading: boolean = false;
  private placesAutocompleteService: any = null;
  private geocoder: any = null;
  private placesMarker: any = null;

  private zoomChangeDebounce: number | null = null;
  private hiddenOriginalMarkers: any[] = [];
  private detachedMarker: any = null;
  private originalStackState: any = null;

  private memoizedBrokenPicturesMap: Set<string> = new Set();
  private imageCompareRegex: RegExp = /(cb=\d+)$/gi;
  private widgetFinderInterval: number | null = null;

  private filters: { deviceId?: string; gatewayId?: string } = {};

  private rssiColor = rssiColor;
  private snrColor = snrColor;
  private spreadingFactorColor = spreadingFactorColor;
  private spreadingFactorColors = SPREADING_FACTOR_COLORS;

  private connectionHistory: any[] = [];
  private timelineValue: number = 0;
  private sliderKey: number = 0;
  private isDragging: boolean = false;
  private scrollInterval: number | null = null;

  private activeChartSelection: { chart: any, seriesIndex: number, dataPointIndex: number } | null = null;
  private chartToastVisible: boolean = false;
  private chartToastData: any = {};

  private selectedHour: number | null = null;
  private dailyCharts: any[] = [];
  private allDailyData: any[] = [];
  private baseChartOptions: any = {
    grid: {
      show: false,
      padding: {
        left: -4,
        right: -5,
        bottom: 0,
      },
    },
    chart: {
      sparkline: { enabled: true },
      animations: { enabled: false },
      type: 'line',
      stacked: true,
      toolbar: { show: false },
      events: {
        dataPointSelection: this.handleChartClick,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'lighten',
        },
      },
    },
    dataLabels: { enabled: false },
    markers: { size: 0, hover: { size: 0 }},
    legend: { show: false },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '80%',
      },
    },
    tooltip: {
      enabled: false,
      shared: true,
      intersect: false,
      followCursor: true,
      custom: ({ series, dataPointIndex, w }: any) => {
        const dateString = w.globals.chartID;
        const hour = String(dataPointIndex).padStart(2, '0');

        const seriesValues: any = {};
        series.forEach((s: any, i: number) => {
          const value = s[dataPointIndex];
          if (typeof value === 'number') {
            const seriesId = w.config.series[i].id;
            const seriesName = w.globals.seriesNames[i];
            const seriesColor = w.globals.colors[i];
            seriesValues[seriesId] = { name: seriesName, value, color: seriesColor };
          }
        });

        const fCount = seriesValues.fCount || { value: 0, color: w.globals.colors[0] };
        const fCountDelta = seriesValues.fCountDelta || { value: 0, color: w.globals.colors[1] };
        const criticalCount = seriesValues.criticalCount || { value: 0, color: w.globals.colors[2] };
        const warningCount = seriesValues.warningCount || { value: 0, color: w.globals.colors[3] };

        const snrData = seriesValues.snr;
        const rssiData = seriesValues.rssi;

        const snrColorString = snrData ? snrData.color : w.globals.colors[4];
        const rssiColorString = rssiData ? rssiData.color : w.globals.colors[5];

        const snrValue = snrData ? snrData.value.toFixed(2) + ' dB' : 'N/A';
        const rssiValue = rssiData ? rssiData.value.toFixed(2) + ' dBm' : 'N/A';


        return `
          <div class="custom-apex-tooltip">
            <div class="tooltip-header d-flex justify-space-between">
              <div>${dateString}</div>
              <div>${hour}:00</div>
            </div>
            <div class="tooltip-body">
              <div class="d-flex justify-space-between">
                <div>
                  <div class="font-weight-bold">Messages</div>
                  <div>
                    <div> <i class="mdi mdi-square" style="color: ${fCount.color}"></i> Received: ${fCount.value}</div>
                    <div> <i class="mdi mdi-square" style="color: ${fCountDelta.color}"></i> Lost: ${fCountDelta.value}</div>
                  </div>
                </div>
                <div>
                  <div class="font-weight-bold">Events</div>
                  <div>
                    <div> <i class="mdi mdi-square" style="color: ${warningCount.color}"></i> Warning: ${warningCount.value}</div>
                    <div> <i class="mdi mdi-square" style="color: ${criticalCount.color}"></i> Critical: ${criticalCount.value}</div>
                  </div>
                </div>
                <div style="width: 105px">
                  <div class="font-weight-bold">Network</div>
                  <div>
                    <div> <i class="mdi mdi-square" style="color: ${snrColorString}"></i> SNR: ${snrValue}</div>
                    <div> <i class="mdi mdi-square" style="color: ${rssiColorString}"></i> RSSI: ${rssiValue}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
  };

  private get chartHeight() {
    const baseHeight = 90;
    const showCharts = this.activePanel !== null &&
        this.selectedLocations[this.activePanel] &&
        this.selectedLocations[this.activePanel].type === 'device';

    if (showCharts) {
      return baseHeight + this.apexChartHeight;
    }
    return baseHeight;
  }

  private get timelineLabels(): string[] {
    if (this.historyDays.length < 1) { return []; }

    const labels = this.historyDays.map((dateStr) => {
      const date = new Date(dateStr);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    });

    labels.push('');

    return labels;
  }

  private get hasTimelineData(): boolean {
    if (this.timelineLoading || this.dailyCharts.length === 0) {
      return false;
    }

    return this.dailyCharts.some((chart) =>
        chart.series.some((series: any) =>
            series.data.some((point: number) => point > 0),
        ),
    );
  }

  private get idealSliderWidth(): number {
    if (this.historyDays.length < 2) {
      return 300;
    }
    return (this.historyDays.length) * (this.dayWidth);
  }

  private get tickSegmentWidth(): number {
    if (this.historyDays.length === 0) {
      return 0;
    }
    return this.idealSliderWidth / this.historyDays.length;
  }

  private get filteredOrgs() {
    if (!this.allProjects.length) {
      return [];
    }
    const allOrgs = this.allProjects.map((p: any) => ({
      organisationName: p.organisationName,
      organisationId: p.organisationId,
    }));

    const uniqueOrgs = allOrgs.reduce((acc: any[], current: any) => {
      const x = acc.find((item) => item.organisationId === current.organisationId);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    if (this.activeItem) {
      return uniqueOrgs.filter((org: any) => org.organisationId === this.activeItem.organisationId);
    }

    return uniqueOrgs.sort((a: any, b: any) => {
      const nameA = a.organisationName || '';
      const nameB = b.organisationName || '';
      return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
    });
  }

  private get disabledForGatewaysAndLora(): boolean {
    if (!this.activeItem) {
      return false;
    }
    return this.activeItem.type === 'gateway' || this.activeItem.bearer === 'lora';
  }

  private get activeItem(): any | null {
    if (this.activePanel !== null && this.selectedLocations[this.activePanel]) {
      return this.selectedLocations[this.activePanel];
    }
    return null;
  }

  private get apexChartHeight(): number {
    const windowHeightThird = window.innerHeight / 3;
    const height = Math.max(windowHeightThird, 300);
    return this.chartsExpanded ? height : 75;
  }

  private async expandCharts() {
    this.chartsLoading = true;
    this.chartToastVisible = false;
    this.chartsExpanded = !this.chartsExpanded;
    this.dailyCharts = [];

    await this.$nextTick();
    await new Promise((resolve) => setTimeout(resolve, 300));
    try {
      this.populateTimelineChart(this.chartsExpanded);
    } catch (e) {
      this.dailyCharts = [];
    } finally {
      setTimeout(() => this.chartsLoading = false, 300);
    }
  }

  @Watch('$route', { immediate: true })
  private onRouteChange(to: { path: string }) {
    if (to.path.includes('/map')) {
      this.hideJiraWidget();
    } else {
      this.showJiraWidget();
    }
  }

  private async mounted() {
    const { deviceId, gatewayId } = this.$route.query;
    this.filters = {
      deviceId: deviceId as string,
      gatewayId: gatewayId as string,
    };

    await this.checkForLoraSettings();
    await this.loadAllData();

    if (!this.locations.length) {
      this.uiDisabled = true;
      return;
    }

    if (!this.allMarkers.length && (this.filters.deviceId || this.filters.gatewayId)) {
      await this.addToastErrorMessage(`No ${ this.filters.deviceId ? 'devices' : 'gateways' } match the queried ID`);

      this.$router.replace({ path: `/map` });
      this.filters = {};

      await this.loadAllData();
    }

    this.generateLegendSVGs();
    this.startAutoRefresh();
    await this.$nextTick();
    await this.createMap();

    this.placesAutocompleteService = new google.maps.places.AutocompleteService();
    this.geocoder = new google.maps.Geocoder();

    this.mapLoading = false;

    window.addEventListener('mouseup', this.stopDrag);
    window.addEventListener('mousemove', this.handleDrag);
    document.documentElement.addEventListener('mouseleave', this.stopDrag);

    if (deviceId) {
      await this.$nextTick();
      const targetMarker = this.allDeviceMarkers.find((m) =>
          m.locationData.some((loc: any) => loc.type === 'device' && loc.id === Number(deviceId)),
      );
      if (targetMarker) {
        this.filterMarkerClicked = true;
        await this.handleMarkerClick(targetMarker.locationData, true, targetMarker);
      }
    }
    if (gatewayId) {
      await this.$nextTick();
      let targetMarker;
      targetMarker = [...new Set(Object.values(this.gatewayMarkers))].find((m: any) =>
          m.locationData.some((loc: any) => loc.id === Number(gatewayId)),
      );
      if (!targetMarker) {
        targetMarker = this.allDeviceMarkers.find((m: any) =>
            m.locationData.some((loc: any) => loc.type === 'gateway' && loc.id === Number(gatewayId)),
        );
      }
      if (targetMarker) {
        this.filterMarkerClicked = true;
        await this.handleMarkerClick(targetMarker.locationData, false, targetMarker);
      }
    }
  }

  private debouncedSearch() {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    if (this.isFilteredViewActive) { return; }

    this.searchDebounce = window.setTimeout(async () => {
      if (!this.globalSearchQuery || this.globalSearchQuery.trim().length < 3) {
        this.combinedSearchResults = [];
        return;
      }
      await this.fetchCombinedSearchResults();
    }, 400);
  }

  private async fetchCombinedSearchResults() {
    this.searchLoading = true;
    const query: any = this.globalSearchQuery;
    const searchParams = { search: query };

    try {
      const locationSearchPromise = WidgetService.getLocations(searchParams)
          .then((locations: any[]) => {
            return locations.map((l) => ({
              id: l.id,
              name: l.name,
              fullName: l.full_location,
              position: l.coords,
              pathCount: l.path && l.path.split('/') && l.path.split('/').length ? l.path.split('/').length : 1,
              type: 'location',
            }));
          });

      const deviceSearchPromise = WidgetService.getDeviceMarkers(searchParams)
          .then((devices: any[]) => {
            return devices.map((d) => ({
              id: d.id,
              name: d.name,
              subtitle: d.fullLocation,
              type: 'device',
            }));
          });

      let gatewaySearchPromise: Promise<any> = Promise.resolve([]);
      if (this.hasGatewaySettings) {
        gatewaySearchPromise = WidgetService.getGatewayMarkers(searchParams)
            .then((gateways: any[]) => {
              return gateways.map((g) => ({
                id: g.id,
                name: g.name || g.gatewayEui,
                subtitle: g.fullLocation,
                type: 'gateway',
              }));
            });
      }

      const placesSearchPromise = new Promise((resolve) => {
        this.placesAutocompleteService.getPlacePredictions({
          input: query,
          bounds: this.map ? this.map.getBounds() : undefined,
        }, (predictions: any[], status: any) => {
          if (status === 'OK' && predictions) {
            resolve(predictions.map((p) => ({
              id: p.place_id,
              name: p.description,
              type: 'place',
            })));
          } else {
            resolve([]);
          }
        });
      });

      const [locationResults, deviceResults, gatewayResults, placesResults]: any = await Promise.all([
        locationSearchPromise,
        deviceSearchPromise,
        gatewaySearchPromise,
        placesSearchPromise,
      ]);

      const newCombinedResults = [];

      if (locationResults.length > 0) {
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push({ headerText: 'Locations', type: 'location', disabled: true });
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push(...locationResults);
      }

      if (deviceResults.length > 0) {
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push({ headerText: 'Devices', type: 'device', disabled: true });
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push(...deviceResults);
      }

      if (gatewayResults.length > 0) {
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push({ headerText: 'Gateways', type: 'gateway', disabled: true });
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push(...gatewayResults);
      }

      if (placesResults.length > 0) {
        newCombinedResults.push({ divider: true, isabled: true });
        newCombinedResults.push({ headerText: 'Places', type: 'place', disabled: true });
        newCombinedResults.push({ divider: true, disabled: true });
        newCombinedResults.push(...placesResults);
      }

      this.combinedSearchResults = newCombinedResults;
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(`Search failed: ${err.message}`);
      this.combinedSearchResults = [];
    } finally {
      this.searchLoading = false;
    }
  }

  private clearSearch() {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = null;
    }
    if (this.selectedSearchItem && this.selectedSearchItem.type !== 'place' && this.selectedSearchItem.type !== 'location') {
      this.selectedLocations = [];
      this.activePanel = null;
    }

    this.globalSearchQuery = null;
    this.selectedSearchItem = null;
    this.combinedSearchResults = [];

    this.clearPlacesMarker();

    this.filters = {};

    if (this.equipmentFilters.length > 0) {
      this.equipmentFilters = [];
    } else {
      this.loadMapMarkers(false);
    }
  }

  private clearPlacesMarker() {
    if (this.placesMarker) {
      this.placesMarker.setMap(null);
      this.placesMarker = null;
    }
  }

  private showJiraWidget(): void {
    const jiraWidget = document.querySelector('iframe[id^="jsd-widget"]');
    if (jiraWidget) {
      (jiraWidget as HTMLElement).style.display = 'block';
    }
  }

  private hideJiraWidget(): void {
    if (this.widgetFinderInterval) {
      clearInterval(this.widgetFinderInterval);
    }

    this.widgetFinderInterval = window.setInterval(() => {
      const jiraWidget = document.querySelector('iframe[id^="jsd-widget"]');

      if (jiraWidget) {
        (jiraWidget as HTMLElement).style.display = 'none';
        clearInterval(this.widgetFinderInterval!);
      }
    }, 500);
  }

  private handleImageError(e: any) {
    if (e.typeImage === '/img/default-device.png') {
      return;
    }

    this.memoizedBrokenPicturesMap.add(e.typeImage.replace(this.imageCompareRegex, ''));
    e.typeImage = '/img/default-device.png';
  }

  private populateTimelineChart(showRadioCharts: boolean = false) {
    if (this.activePanel === null || !this.historyDays.length) {
      this.dailyCharts = [];
      return;
    }

    const selected = this.selectedLocations[this.activePanel];
    if (!selected || selected.type !== 'device') {
      this.dailyCharts = [];
      return;
    }

    const dataByDate = new Map(this.allDailyData.map((dayData: any) => [dayData.date, dayData.hourlyData]));

    let globalMaxY1 = 0;
    let globalMaxY2 = 0;
    let globalMinY2 = 0;
    const globalMaxY3 = 20;
    const globalMinY3 = -20;
    for (const hourlyData of dataByDate.values()) {
      for (const hour of hourlyData) {
        const hourlyTotal = (hour.fCount || 0) + (hour.criticalCount || 0) + (hour.warningCount || 0);
        if (hourlyTotal > globalMaxY1) {
          globalMaxY1 = hourlyTotal;
        }
        const rssi = hour.avgRssi;
        if (typeof rssi === 'number' && rssi !== 0) {
          if (rssi > globalMaxY2) {
            globalMaxY2 = rssi;
          }
          if (rssi < globalMinY2) {
            globalMinY2 = rssi;
          }
        }
      }
    }
    globalMaxY1 = Math.max(Math.ceil(globalMaxY1 * 1.1), 6);
    if (globalMinY2 === 0 || globalMaxY2 === 0) {
      globalMinY2 = -120;
      globalMaxY2 = 50;
    } else {
      const range = globalMaxY2 - globalMinY2;
      const padding = Math.max(range * 0.1, 5);
      globalMaxY2 = Math.ceil(globalMaxY2 + padding);
      globalMinY2 = Math.floor(globalMinY2 - padding);
    }

    const dailyCharts = this.historyDays.map((dayString) => {
      const hourlyDataForDay = dataByDate.get(dayString) || Array.from({ length: 24 }, (el, hour) => ({ hour, fCount: 0, fCountDelta: 0, criticalCount: 0, warningCount: 0, avgSnr: 0, avgRssi: 0 }));

      const strokeWidths = [0, 0, 0, 0];
      const chartColors = ['#016EA1', '#ED8D28', '#d10000', '#fcc911', '#00E396', '#D05DAA'];
      const dataSets: {
        fCount: Array<number | null>,
        fCountDelta: Array<number | null>,
        criticalCount: Array<number | null>,
        warningCount: Array<number | null>,
        snr: Array<number | null>,
        rssi: Array<number | null>,
      } = {
        fCount: [],
        fCountDelta: [],
        criticalCount: [],
        warningCount: [],
        snr: [],
        rssi: [],
      };

      for (const h of hourlyDataForDay) {
        const fc = h.fCount || 0;
        const fd = h.fCountDelta || 0;
        dataSets.fCount.push(fd > fc ? 1 : fc - fd);
        dataSets.fCountDelta.push(h.fCountDelta || 0);
        dataSets.criticalCount.push(h.criticalCount || 0);
        dataSets.warningCount.push(h.warningCount || 0);

        if (showRadioCharts) {
          dataSets.snr.push(typeof h.avgSnr === 'number' && h.avgSnr !== 0 ? h.avgSnr : null);
          dataSets.rssi.push(typeof h.avgRssi === 'number' && h.avgRssi !== 0 ? h.avgRssi : null);
        }
      }

      const series = [
        { name: 'Messages Received', data: dataSets.fCount, id: 'fCount', type: 'column', group: 'cols'},
        { name: 'Packets Lost', data: dataSets.fCountDelta, id: 'fCountDelta', type: 'column', group: 'cols' },
        { name: 'Critical Events', data: dataSets.criticalCount, id: 'criticalCount', type: 'column', group: 'cols' },
        { name: 'Warning Events', data: dataSets.warningCount, id: 'warningCount', type: 'column', group: 'cols' },
      ];

      const yaxis: Record<string, any> = [
        {
          seriesName: ['Messages Received', 'Packets Lost', 'Critical Events', 'Warning Events'],
          max: globalMaxY1,
          min: 0,
          forceNiceScale: true,
          labels: {
            show: false,
            formatter: (val: number) => {
              if (val === null || val === undefined) { return ''; }
              return val.toFixed(0);
            },
          },
        },
      ];

      if (showRadioCharts) {
        strokeWidths.push(4, 4);

        series.push({ name: 'SNR', data: dataSets.snr, id: 'snr', type: 'line', group: 'lines' });
        series.push({ name: 'RSSI', data: dataSets.rssi, id: 'rssi', type: 'line', group: 'lines' });

        yaxis.push({
          seriesName: 'SNR',
          min: globalMinY3,
          max: globalMaxY3,
          show: false,
          opposite: true,
          labels: {
            show: false,
            formatter: (val: number) => {
              if (val === null || val === undefined) { return ''; }
              return val.toFixed(2);
            },
          },
        });

        yaxis.push({
          seriesName: 'RSSI',
          show: false,
          min: globalMinY2,
          max: globalMaxY2,
          opposite: true,
          labels: {
            show: false,
            formatter: (val: number) => {
              if (val === null || val === undefined) { return ''; }
              return val.toFixed(0);
            },
          },
        });
      }

      return {
        series,
        options: {
          ...this.baseChartOptions,
          chart: {
            ...this.baseChartOptions.chart,
            id: dayString,
          },
          colors: chartColors,
          stroke: {
            width: strokeWidths,
          },
          yaxis,
          tooltip: {
            ...this.baseChartOptions.tooltip,
            x: {
              formatter: (val: number, {dataPointIndex}: { dataPointIndex: number }) => {
                const date = new Date(dayString);
                const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                return `${formattedDate} ${String(dataPointIndex).padStart(2, '0')}:00`;
              },
            },
          },
        },
      };
    });

    this.dailyCharts = dailyCharts;
  }

  private getIconForSearch(type: string): string {
    switch (type) {
      case 'device': return 'mdi-rss';
      case 'gateway': return 'mdi-router-wireless';
      case 'location': return 'mdi-map-marker';
      case 'place': return 'mdi-map';
      default: return 'mdi-magnify';
    }
  }

  private async findAndClickMarker(item: any) {
    await this.$nextTick();

    let targetMarker: any;
    if (item.type === 'device') {
      targetMarker = this.allDeviceMarkers.find((m) =>
          m.locationData.some((loc: any) => loc.type === 'device' && loc.id === item.id),
      );
    } else if (item.type === 'gateway') {
      targetMarker = [...new Set(Object.values(this.gatewayMarkers))].find((m: any) =>
          m.locationData.some((loc: any) => loc.id === item.id),
      );
      if (!targetMarker) {
        targetMarker = this.allDeviceMarkers.find((m: any) =>
            m.locationData.some((loc: any) => loc.type === 'gateway' && loc.id === item.id),
        );
      }
    }

    if (targetMarker) {
      this.filterMarkerClicked = true;
      const pos = targetMarker.position;
      this.map.setCenter(pos);
      await this.handleMarkerClick(targetMarker.locationData, item.type === 'device', targetMarker, item.id);
    }
  }

  private generateLegendSVGs(disabled: boolean = false) {
    this.deviceSvg = MarkerFactory.createDeviceMarkerSVG(MarkerFactory.getDeviceStatusColor(this.disabledForGatewaysAndLora ? 'inactive' : 'active'), MarkerFactory.getSpreadingFactorColor(0), 0.94).outerHTML;
    this.gatewaySvg = MarkerFactory.createGatewayIcon(MarkerFactory.getGatewayStatusColor(this.disabledForGatewaysAndLora ? 'inactive' : 'active'), 0.75).outerHTML;
    this.activeSvg = MarkerFactory.createCombinedStatusMarkerSVG(MarkerFactory.getDeviceStatusColor(this.disabledForGatewaysAndLora ? 'inactive' : 'active')).outerHTML;
    this.faultSvg = MarkerFactory.createCombinedStatusMarkerSVG(MarkerFactory.getDeviceStatusColor(this.disabledForGatewaysAndLora ? 'inactive' : 'fault')).outerHTML;
  }

  private debounceLayerUpdate(resetBounds: boolean) {
    this.layersLoading = true;

    if (this.layerUpdateTimeout) {
      clearTimeout(this.layerUpdateTimeout);
    }

    this.layerUpdateTimeout = window.setTimeout(() => {
      this.applyFiltersAndRedraw(resetBounds);
      this.layersLoading = false;
    }, 1100);
  }

  private async createMap() {
    if (this.$refs && this.$refs.expandedMap) {
      const { Map } = await (google.maps as any).importLibrary('maps') as any;
      const { AdvancedMarkerElement } = await (google.maps as any).importLibrary('marker') as any;

      this.map = new Map(this.$refs.expandedMap as HTMLElement, {
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        mapTypeId: 'roadmap',
        fullscreenControl: false,
        streetViewControl: false,
        mapId: 'afe3e0e97cbe7a49b1f20df9',
        clickableIcons: false,
        gestureHandling: 'greedy',
      });
      this.AdvancedMarkerElement = AdvancedMarkerElement;

      this.map.addListener('click', this.closePanel);

      this.map.addListener('zoom_changed', () => {
        if (this.zoomChangeDebounce) {
          clearTimeout(this.zoomChangeDebounce);
        }
        if (this.historyVisible) {
          this.zoomChangeDebounce = window.setTimeout(() => {
            this.onSliderEnd(this.timelineValue);
          }, 400);
        }
      });

      this.applyFiltersAndRedraw();
      this.$emit('mapLoaded');
    }
  }

  private updateMapForHistoricalView(activeItem: any, connections: any[]) {
    if (connections.length === 0) {
      this.allDeviceMarkers.forEach((marker) => {
        if (marker.content) {
          marker.content.style.opacity = '1';
        }
      });
      Object.values(this.gatewayMarkers).forEach((marker) => {
        if (marker.content) {
          marker.content.style.opacity = '1';
        }
      });
      return;
    }

    const activeDeviceIds = new Set<number>();
    const activeGatewayIdentifiers = new Set<string>();
    const diff = 0.001;

    if (activeItem.type === 'device') {
      activeDeviceIds.add(activeItem.id);
      connections.forEach((c) => activeGatewayIdentifiers.add(this.getGatewayIdentifier(c) as string));
    } else {
      activeGatewayIdentifiers.add(this.getGatewayIdentifier(activeItem) as string);
      connections.forEach((c) => activeDeviceIds.add(c.device_id));
    }

    this.allDeviceMarkers.forEach((marker) => {
      if (marker === this.selectedMarker) { return; }

      const hasRelatedDevice = marker.locationData.some((item: any) => item.type === 'device' && activeDeviceIds.has(item.id));
      const hasRelatedGateway = marker.locationData.some((item: any) => item.type === 'gateway' && activeGatewayIdentifiers.has(this.getGatewayIdentifier(item) as string));
      const isRelated = hasRelatedDevice || hasRelatedGateway;

      if (isRelated) {
        const hasAnyItemMoved = marker.locationData.some((itemInStack: any) => {
          const connectionData = itemInStack.type === 'device'
              ? connections.find((c) => c.device_id === itemInStack.id)
              : connections.find((c) => this.getGatewayIdentifier(c) === this.getGatewayIdentifier(itemInStack));

          if (!connectionData) {
            return false;
          }

          const historicalLat = activeItem.type === 'device' ? connectionData.lat : connectionData.lat;
          const historicalLng = activeItem.type === 'device' ? connectionData.lng : connectionData.lng;

          if (!historicalLat || !historicalLng) {
            return false;
          }

          const originalPosition = marker.position;
          const originalLat = typeof originalPosition.lat === 'function' ? originalPosition.lat() : originalPosition.lat;
          const originalLng = typeof originalPosition.lng === 'function' ? originalPosition.lng() : originalPosition.lng;

          return (Math.abs(originalLat - historicalLat) > diff || Math.abs(originalLng - historicalLng) > diff);
        });

        if (hasAnyItemMoved) {
          marker.map = null;
          this.hiddenOriginalMarkers.push(marker);

          for (const itemInStack of marker.locationData) {
            const connectionData = itemInStack.type === 'device'
                ? connections.find((c) => c.device_id === itemInStack.id)
                : connections.find((c) => this.getGatewayIdentifier(c) === this.getGatewayIdentifier(itemInStack));

            const originalPosition = marker.position;
            const originalLat = typeof originalPosition.lat === 'function' ? originalPosition.lat() : originalPosition.lat;
            const originalLng = typeof originalPosition.lng === 'function' ? originalPosition.lng() : originalPosition.lng;

            let historicalLat = originalLat;
            let historicalLng = originalLng;
            if (connectionData) {
              historicalLat = (activeItem.type === 'device' ? connectionData.lat : connectionData.lat) || originalLat;
              historicalLng = (activeItem.type === 'device' ? connectionData.lng : connectionData.lng) || originalLng;
            }

            let movedMarkerContent;
            let identifier;

            if (itemInStack.type === 'device') {
              const statusColor = MarkerFactory.getDeviceStatusColor(itemInStack.status);
              const sfColor = MarkerFactory.getSpreadingFactorColor(itemInStack.loraSpreadingFactor);
              movedMarkerContent = MarkerFactory.createDeviceMarkerSVG(statusColor, sfColor);
              identifier = itemInStack.id;
            } else { // gateway
              const statusColor = MarkerFactory.getGatewayStatusColor(itemInStack.status);
              movedMarkerContent = MarkerFactory.createGatewayIcon(statusColor);
              identifier = this.getGatewayIdentifier(itemInStack);
            }

            const movedMarker = new this.AdvancedMarkerElement({
              map: this.map,
              position: { lat: historicalLat, lng: historicalLng },
              content: movedMarkerContent,
              zIndex: 1000,
            });
            (movedMarker as any).identifier = identifier;
            this.ghostMarkers.push(movedMarker);
          }
        } else {
          marker.content.style.opacity = '1';
        }
      } else {
        marker.content.style.opacity = '0.1';
      }
    });

    const uniqueGatewayMarkers = [...new Set(Object.values(this.gatewayMarkers))];
    uniqueGatewayMarkers.forEach((marker) => {
      if (marker === this.selectedMarker) { return; }
      const isRelated = marker.locationData.some((gatewayInData: any) =>
          activeGatewayIdentifiers.has(this.getGatewayIdentifier(gatewayInData) as string),
      );

      if (isRelated) {
        const connectionData = connections.find((c) => marker.locationData.some((gw: any) => this.getGatewayIdentifier(c) === this.getGatewayIdentifier(gw)));
        const originalPosition = marker.position;
        const originalLat = typeof originalPosition.lat === 'function' ? originalPosition.lat() : originalPosition.lat;
        const originalLng = typeof originalPosition.lng === 'function' ? originalPosition.lng() : originalPosition.lng;
        const hasMoved = connectionData && connectionData.lat && connectionData.lng &&
            (Math.abs(originalLat - connectionData.lat) > diff || Math.abs(originalLng - connectionData.lng) > diff);
        if (hasMoved) {
          marker.map = null;
          this.hiddenOriginalMarkers.push(marker);
          const originalStatus = marker.locationData[0].status;
          const statusColor = MarkerFactory.getGatewayStatusColor(originalStatus);
          const movedMarker = new this.AdvancedMarkerElement({
            map: this.map,
            position: { lat: connectionData.lat, lng: connectionData.lng },
            content: MarkerFactory.createGatewayIcon(statusColor),
            zIndex: 1000,
          });
          (movedMarker as any).identifier = this.getGatewayIdentifier(connectionData);
          this.ghostMarkers.push(movedMarker);
        } else {
          marker.content.style.opacity = '1';
        }
      } else {
        marker.content.style.opacity = '0.1';
      }
    });
  }

  private async loadAllData(resetBounds: boolean =  true) {
    await Promise.all([this.loadMapMarkers(resetBounds), this.loadProjects()]);
  }

  private async loadProjects() {
    const projects = await WidgetService.getProjects();
    this.allProjects = projects;
    this.allOrgs = this.allProjects.map((p: any) => ({
      organisationName: p.organisationName,
      organisationId: p.organisationId,
    }));
  }

  private async loadMapMarkers(resetBounds: boolean = true) {
    this.mapLoading = true;
    try {
      let deviceMarkersPromise;
      let gatewayMarkersPromise;

      const params: { deviceId?: string, gatewayId?: string, search?: string } = {};

      if (this.filters.deviceId) {
        params.deviceId = this.filters.deviceId;
      } else if (this.filters.gatewayId) {
        params.gatewayId = this.filters.gatewayId;
      } else if (this.globalSearchQuery && this.globalSearchQuery.trim() !== '') {
        params.search = this.globalSearchQuery;
      }

      deviceMarkersPromise = WidgetService.getDeviceMarkers(params);
      gatewayMarkersPromise = this.hasGatewaySettings
          ? WidgetService.getGatewayMarkers(params)
          : Promise.resolve([]);

      const [ devMarkers, gwayMarkers ] = await Promise.all([
        deviceMarkersPromise,
        this.hasGatewaySettings ? gatewayMarkersPromise : Promise.resolve([]),
      ]);
      this.allMarkers = [...devMarkers, ...gwayMarkers];
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.mapLoading = false;
      this.applyFiltersAndRedraw(resetBounds);
    }
  }

  private async getProjects(orgId: number) {
    if (!orgId) {
      this.projects = [];
      return;
    }
    this.loadingProjects = true;
    try {
      this.projects = this.allProjects
          .filter((d: { organisationId: number }) => d.organisationId === orgId)
          .map((d: any) => ({
            id: d.projectId,
            name: d.projectName,
            organisationId: d.organisationId,
            organisationName: this.getOrgName(d),
          }))
          .filter((p: any, i: number, self: any) => i === self.findIndex((t: { id: number }) => t.id === p.id));
      this.projects.sort((a: Project, b: Project) => (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase()));
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.loadingProjects = false;
    }
  }

  private async checkForLoraSettings(): Promise<void> {
    try {
      if (this.hasPermission('gateway:read') || this.hasPermission('inventory:read')) {
        const hasGatewaySettings = await WidgetService.hasGatewaySettings();
        this.hasGatewaySettings = hasGatewaySettings.result;
      } else {
        this.hasGatewaySettings = false;
      }
      this.$emit('hasGatewaySettings', this.hasGatewaySettings);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    }
  }

  private async filterOrganisation(orgId: number) {
    this.projectFilter = null;
    this.projects = [];
    await this.getProjects(orgId);

    this.applyFiltersAndRedraw(false);
    this.updateSelectedLocations();
  }

  private async filterProject() {
    this.applyFiltersAndRedraw(false);
    this.updateSelectedLocations();
  }

  private async clearFilter() {
    this.orgFilter = null;
    this.projectFilter = null;
    this.projects = [];
    this.generateLegendSVGs();
    this.applyFiltersAndRedraw(false);
    this.updateSelectedLocations();
  }

  private async clearEquipmentFilters(filter: string) {
    this.filters = {};
    this.equipmentFilters = this.equipmentFilters.filter((f) => f === filter);
    this.closePanel();

    const query = Object.assign({}, this.$route.query);
    delete query[Object.keys(this.$route.query)[0]];
    this.$router.replace({ query });
    await this.loadAllData(false);
  }

  private applyFiltersAndRedraw(resetBounds: boolean = true) {
    this.connectionHistory = [];
    let filteredMarkers = [...this.allMarkers];

    if (this.orgFilter) {
      filteredMarkers = filteredMarkers.filter((d) => d.organisationId === this.orgFilter);
    }
    if (this.projectFilter) {
      filteredMarkers = filteredMarkers.filter((d) => d.projectId === this.projectFilter);
    }

    if (this.statusFilters.length > 0) {
      filteredMarkers = filteredMarkers.filter((d) => this.statusFilters.includes(d.status));
    } else {
      filteredMarkers = [];
    }

    filteredMarkers = filteredMarkers.filter((marker) => this.visibleMarkers.includes(marker.type + 's'));

    const tempDevices = filteredMarkers.filter((m) => m.type === 'device');
    const tempGateways = filteredMarkers.filter((m) => m.type === 'gateway');

    this.deviceLocations = tempDevices;
    this.gatewayLocations = tempGateways;

    this.locations = filteredMarkers;

    this.setMapOptions(resetBounds);
  }

  private async setMapOptions(resetBounds: boolean = true) {
    this.clearMap();
    if (!this.map) {
      return;
    }


    if (!this.locations.length && !this.visibleMarkers.length) {
      this.map.setCenter({ lat: 51.5072, lng: 0.1276 });
      this.map.setZoom(3);
      return;
    }

    const locationGroups = this.groupLocations(this.locations);

    for (const group of Object.values(locationGroups) as any[][]) {
      const hasDevices = group.some((item) => item.type === 'device');
      const hasGateways = group.some((item) => item.type === 'gateway');

      if (hasDevices && hasGateways) {
        const marker = this.generateCombinedPin(group);
        this.allDeviceMarkers.push(marker);
      } else if (hasDevices) {
        const marker = this.generateDevicePin(group);
        this.allDeviceMarkers.push(marker);
      } else if (hasGateways) {
        this.generateGatewayMarkers(this.map, group);
      }
    }


    const renderer: any = this.createClusterRenderer();
    this.markerClusterer = new MarkerClusterer({
      map: this.map,
      markers: this.allDeviceMarkers,
      renderer,
      algorithmOptions: { maxZoom: 8 },
    });

    if (resetBounds) {
      this.fitBounds();
    }
  }

  private generateCombinedPin(locations: any[]) {
    const sortedLocations = this.sortLocationsForDisplay(locations);
    const markerSVG = MarkerFactory.createCombinedMarkerSVG(sortedLocations);
    const marker = new this.AdvancedMarkerElement({
      position: { lat: Number(locations[0].lat), lng: Number(locations[0].lng) },
      content: markerSVG,
      title: `${locations.length} items at this location`,
    });
    (marker as any).locationData = locations;
    marker.addListener('click', (e: any) => {
      e.stop();
      this.handleMarkerClick(locations, true, marker);
    });
    return marker;
  }

  private groupLocations(locations: any[]) {
    return locations.reduce((acc, loc) => {
      if (!loc.lat || !loc.lng) { return acc; }
      const key = `${loc.lat},${loc.lng}`;
      if (!acc[key]) { acc[key] = []; }
      acc[key].push(loc);
      return acc;
    }, {});
  }

  private clearMap() {
    if (this.markerClusterer) { this.markerClusterer.clearMarkers(); }
    Object.values(this.gatewayMarkers).forEach((m) => m.map = null);
    this.allDeviceMarkers = [];
    this.gatewayMarkers = {};
  }

  private fitBounds() {
    const visibleLocations = [];
    if (this.visibleMarkers.includes('devices')) { visibleLocations.push(...this.deviceLocations); }
    if (this.visibleMarkers.includes('gateways')) { visibleLocations.push(...this.gatewayLocations); }
    if (visibleLocations.length === 0) { return; }

    const bounds = new google.maps.LatLngBounds();
    visibleLocations.forEach((loc: {lat: string; lng: string}) => {
      if (loc.lat && loc.lng) { bounds.extend(new google.maps.LatLng(Number(loc.lat), Number(loc.lng))); }
    });

    if (visibleLocations.length === 1 || (bounds.getNorthEast() && bounds.getNorthEast().equals(bounds.getSouthWest()))) {
      this.map.setCenter(bounds.getCenter());
      this.map.setZoom(this.DEFAULT_ZOOM);
    } else {
      this.map.fitBounds(bounds);
    }
  }

  private generateDevicePin(locations: any[], hasGateways: boolean = false, gatewayCount?: number) {
    const sortedLocations = this.sortLocationsForDisplay(locations);

    const location = sortedLocations[0];

    let markerSVG;
    if (locations.length > 1 || hasGateways) {
      markerSVG = MarkerFactory.createStackedDeviceMarkerSVG(sortedLocations, undefined);
    } else {
      const statusColor = MarkerFactory.getDeviceStatusColor(location.status);
      const sfColor = MarkerFactory.getSpreadingFactorColor(location.network && location.network.loraSpreadingFactor ? location.network.loraSpreadingFactor : undefined);
      markerSVG = MarkerFactory.createDeviceMarkerSVG(statusColor, sfColor);
    }

    const marker = new this.AdvancedMarkerElement({
      position: { lat: Number(location.lat), lng: Number(location.lng) },
      content: markerSVG,
      title: `${locations.length} device(s)${ hasGateways ? ` and ${gatewayCount} gateway(s) ` : ' ' }at this location`,
    });

    (marker as any).locationData = locations;
    marker.addListener('click', (e: any) => {
      e.stop();
      this.handleMarkerClick(locations, true, marker);
    });
    return marker;
  }

  private sortLocationsForDisplay(locations: any[]): any[] {
    return [...locations].sort((a, b) => {
      const siteA = a.siteName || '';
      const siteB = b.siteName || '';
      if (siteA.localeCompare(siteB) !== 0) {
        return siteA.localeCompare(siteB);
      }

      const statusOrder: { [key: string]: number } = { fault: 1, inactive: 2, active: 3 };
      const statusA = statusOrder[a.status] || 99;
      const statusB = statusOrder[b.status] || 99;
      if (statusA !== statusB) {
        return statusA - statusB;
      }

      if (a.type === 'gateway' && b.type !== 'gateway') { return -1; }
      if (a.type !== 'gateway' && b.type === 'gateway') { return 1; }

      const nameA = a.deviceName || a.gatewayEui || '';
      const nameB = b.deviceName || b.gatewayEui || '';
      return nameA.localeCompare(nameB);
    });
  }

  private shouldShowSiteHeader(item: any, index: number): boolean {
    if (!item || !item.siteName) {
      return false;
    }
    if (index === 0) {
      return true;
    }
    const prevItem = this.selectedLocations[index - 1];
    return item.siteName !== prevItem.siteName;
  }

  private generateGatewayMarkers(map: google.maps.Map, locations: any[]) {
    const location = locations[0];
    let markerContent;

    if (locations.length > 1) {
      markerContent = MarkerFactory.createStackedGatewayMarkerSVG(locations);
    } else {
      markerContent = MarkerFactory.createGatewayIcon(MarkerFactory.getGatewayStatusColor(location.status));
    }

    const marker = new this.AdvancedMarkerElement({
      map,
      position: { lat: Number(location.lat), lng: Number(location.lng) },
      content: markerContent,
      title: `${locations.length} gateway(s) at this location`,
    });

    (marker as any).locationData = locations;
    marker.addListener('click', (e: any) => {
      e.stop();
      this.handleMarkerClick(locations, false, marker);
    });

    locations.forEach((gw) => {
      this.gatewayMarkers[gw.gatewayEui.toUpperCase()] = marker;
    });
  }


  private createClusterRenderer() {
    return {
      render: ({ count, position, markers }: {
        count: number;
        position: google.maps.LatLngLiteral;
        markers: Array<any & { locationData?: any[] }>;
      }) => {
        if (markers && markers.length > 1) {
          const totalDeviceCount = markers.reduce((acc: any, marker: any) => acc + ((marker as any).locationData && (marker as any).locationData.length || 0), 0);
          return new this.AdvancedMarkerElement({
            position,
            content: MarkerFactory.createClusterIcon(totalDeviceCount),
            zIndex: 1000 + count,
          });
        }
        return markers ? markers[0] : new this.AdvancedMarkerElement({ position });
      },
    };
  }

  private async handleMarkerClick(locations: any[], isDevice: boolean, marker: any, specificItemId?: number | string) {
    if (this.isFilteredViewActive && !this.filterMarkerClicked) {
      return;
    }

    if (this.detachedMarker) {
      this.restackMarker();
    }

    this.resetHistoricalViewState();
    if (this.selectedMarker && this.selectedMarker !== marker) {
      this.resetSelectedMarkerStyle();
    }
    this.selectedMarker = marker;
    this.drawerVisible = true;
    this.selectedLocations = [];
    this.activePanel = null;
    this.layersLoading = true;

    this.clearChartSelection();

    try {
      const deviceIds = locations.filter((loc) => loc.type === 'device').map((loc) => loc.id);
      const gatewayIdentifiers = locations.filter((loc) => loc.type === 'gateway').map((loc) => loc.gatewayEui);
      const detailedItems = await WidgetService.getBatchDetails({ deviceIds, gatewayIdentifiers });

      if (this.filters.deviceId && !this.globalSearchQuery) {
        const device = detailedItems.find((d) => Number(d.id) === Number(this.filters.deviceId));
        const label = device ? device.deviceName : this.filters.deviceId;
        this.equipmentFilters.push(label);
      } else if (this.filters.gatewayId && !this.globalSearchQuery) {
        const gateway = detailedItems.find((d) => Number(d.id) === Number(this.filters.gatewayId));
        const label = gateway ? gateway.gatewayEui : this.filters.gatewayId;
        this.equipmentFilters.push(label);
      }

      detailedItems.forEach((item) => {
        if (item.type === 'device') {
          item.displayNetwork = item.network ? { ...item.network } : {};
        }
        item.displayLocation = { lat: item.lat, lng: item.lng };
      });

      this.unfilteredSelectedLocations = this.sortLocationsForDisplay(detailedItems);
      this.selectedLocations = [...this.unfilteredSelectedLocations];

      this.$nextTick(() => {
        if (specificItemId) {
          const targetIndex = this.selectedLocations.findIndex((loc: any) => {
            if (loc.id === specificItemId) { return true; }
            if (loc.type === 'gateway' && loc.gatewayEui === specificItemId) { return true; }
            return false;
          });

          if (targetIndex !== -1) {
            this.activePanel = targetIndex;
            setTimeout(() => {
              const container = this.$refs.detailsPanel as HTMLElement;
              if (container) {
                const headers = container.querySelectorAll('.v-expansion-panel-header');
                const targetHeader = headers[targetIndex];
                if (targetHeader) {
                  targetHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }
            }, 200);
          } else {
            this.activePanel = 0;
          }
        } else {
          this.activePanel = 0;
        }
      });
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.layersLoading = false;
      this.filterMarkerClicked = false;
    }
  }

  private handleChartClick(event: any, chartContext: any, config: any) {
    const { dataPointIndex, seriesIndex } = config;
    const { w } = chartContext;

    if (this.activeChartSelection && (this.activeChartSelection.chart.w.globals.chartID !== chartContext.w.globals.chartID)) {
      this.activeChartSelection.chart.toggleDataPointSelection(
          this.activeChartSelection.seriesIndex,
          this.activeChartSelection.dataPointIndex,
      );
      this.activeChartSelection = null;
    }

    this.activeChartSelection = {
      chart: chartContext,
      seriesIndex,
      dataPointIndex,
    };

    if (dataPointIndex < 0) {
      this.clearChartSelection();
      return;
    }

    const series = w.globals.series;
    const dateString = w.globals.chartID;
    const hour = String(dataPointIndex).padStart(2, '0');

    const seriesValues: any = {};
    series.forEach((s: any, i: number) => {
      const value = s[dataPointIndex];
      if (typeof value === 'number') {
        const seriesId = w.config.series[i].id;
        const seriesName = w.globals.seriesNames[i];
        const seriesColor = w.globals.colors[i];
        seriesValues[seriesId] = { name: seriesName, value, color: seriesColor };
      }
    });

    const fCount = seriesValues.fCount || { value: 0, color: w.globals.colors[0] };
    const fCountDelta = seriesValues.fCountDelta || { value: 0, color: w.globals.colors[1] };
    const criticalCount = seriesValues.criticalCount || { value: 0, color: w.globals.colors[2] };
    const warningCount = seriesValues.warningCount || { value: 0, color: w.globals.colors[3] };

    const snrData = seriesValues.snr;
    const rssiData = seriesValues.rssi;

    const snrColorString = snrData ? snrData.color : w.globals.colors[4];
    const rssiColorString = rssiData ? rssiData.color : w.globals.colors[5];

    const snrValue = snrData ? snrData.value.toFixed(2) + ' dB' : 0;
    const rssiValue = rssiData ? rssiData.value.toFixed(2) + ' dBm' : 0;

    this.chartToastData = {
      dateString,
      hour,
      fCount,
      fCountDelta,
      criticalCount,
      warningCount,
      snrData: { ...(snrData || {}), color: snrColorString },
      rssiData: { ...(rssiData || {}), color: rssiColorString },
      snrValue,
      rssiValue,
    };

    this.chartToastVisible = true;
  }

  private toggleStatusFilter(status: string) {
    const index = this.statusFilters.indexOf(status);
    if (index > -1) {
      this.statusFilters.splice(index, 1);
    } else {
      this.statusFilters.push(status);
    }
  }

  private toggleLayerFilter(layer: string) {
    const index = this.visibleMarkers.indexOf(layer);
    if (index > -1) {
      this.visibleMarkers.splice(index, 1);
    } else {
      this.visibleMarkers.push(layer);
    }
  }

  private closePanel() {
    this.drawerVisible = false;
    this.clearChartSelection();
  }

  private clearChartSelection() {
    if (this.activeChartSelection) {
      this.activeChartSelection.chart.toggleDataPointSelection(
          this.activeChartSelection.seriesIndex,
          this.activeChartSelection.dataPointIndex,
      );
      this.activeChartSelection = null;
    }
    this.chartToastVisible = false;
    this.chartToastData = {};
  }

  private resetSelectedMarkerStyle() {
    if (!this.selectedMarker) { return; }

    const locationData = (this.selectedMarker as any).locationData;
    if (!locationData || !locationData.length) { return; }

    const isDeviceMarker = locationData[0] && locationData[0].hasOwnProperty('deviceName');
    if (!isDeviceMarker) { return; }

    const sortedLocations = [...locationData].sort((a, b) => {
      const nameA = a.name || a.locationName || '';
      const nameB = b.name || b.locationName || '';
      return nameA.localeCompare(nameB);
    });

    let newSVG;
    if (locationData.length > 1) {
      newSVG = MarkerFactory.createStackedDeviceMarkerSVG(sortedLocations);
    } else {
      const defaultItem = sortedLocations[0];
      const statusColor = MarkerFactory.getDeviceStatusColor(defaultItem.status);
      const sfColor = MarkerFactory.getSpreadingFactorColor(defaultItem.network && defaultItem.network.loraSpreadingFactor ? defaultItem.sloraSpreadingFactor : undefined);
      newSVG = MarkerFactory.createDeviceMarkerSVG(statusColor, sfColor);
    }
    this.selectedMarker.content = newSVG;
  }

  private getOrgName(item: any) {
    if (!this.allOrgs || !this.allOrgs.length || !this.allOrgs.find((org: {organisationId: number}) => item.organisationId === org.organisationId)) {
      return '';
    }
    return this.allOrgs.find((org: {organisationId: number}) => item.organisationId === org.organisationId).organisationName;
  }

  private getStatusColor(status?: string): string {
    if (status === 'fault' || status === 'offline') { return 'error'; }
    if (status === 'active') { return 'success'; }
    return 'grey';
  }

  private spreadingFactorBarMarkerPosition(spreadingFactor: number): string {
    if (spreadingFactor === null) { return '0'; }
    const index = this.spreadingFactorColors.findIndex((sf) => sf.sf === spreadingFactor);
    if (index === -1) { return '0'; }
    const numSteps = this.spreadingFactorColors.length;
    const stepWidthPercentage = 100 / numSteps;
    const positionPercentage = (index * stepWidthPercentage) + (stepWidthPercentage / 2);
    return `${positionPercentage}%`;
  }

  private async selectItemFromList(itemToSelect: any) {
    let marker;
    const identifier = itemToSelect.type === 'device' ? itemToSelect.id : this.getGatewayIdentifier(itemToSelect);

    if (itemToSelect.type === 'gateway') {
      marker = this.gatewayMarkers[identifier.toUpperCase()];

      if (!marker) {
        marker = this.allDeviceMarkers.find((m) =>
            m.locationData.some((loc: any) =>
                loc.type === 'gateway' && this.getGatewayIdentifier(loc) === identifier,
            ),
        );
      }
    } else {
      marker = this.allDeviceMarkers.find((m) =>
          m.locationData.some((loc: any) =>
              loc.type === 'device' && loc.id === identifier,
          ),
      );
    }

    if (marker) {
      await this.handleMarkerClick(marker.locationData, itemToSelect.type === 'device', marker);
      const newIndex = this.selectedLocations.findIndex((item) => {
        const itemId = item.type === 'device' ? item.id : this.getGatewayIdentifier(item);
        return itemId === identifier;
      });

      if (newIndex > -1) {
        this.$nextTick(() => {
          this.activePanel = newIndex;
        });
      }
    }
  }

  private async goToDeviceInfo(data: any) {
    if (data.locationName) {
      await this.goToDeviceDetails(data.organisationId, 0, data.id);
    }
  }

  private async goToGatewayInfo(data: any) {
    if (data.locationName) {
      await this.goToGatewayDetails(data.organisationId, 0, data.id);
    }
  }

  private async goToComposer(data: any) {
    if (this.activeOrganisation === data.organisationId) {
      await this.changeProjectAsync({projectId: data.projectId, forceRender: false});
    } else {
      await this.changeOrganisationAsync({ orgId: data.organisationId, forceRender: false });
      await this.changeProjectAsync({projectId: data.projectId, forceRender: false});
    }
    this.$router.push({
      name: 'projectcomposer',
      params: {organisationId: data.organisationId.toString(), id: data.locationId.toString()},
    });
  }

  private async goToDeviceDetails(organisationId: string, projectId: number, id: number) {
    this.loadingDetails = true;
    if (this.activeOrganisation === organisationId) {
      await this.changeProjectAsync({projectId, forceRender: false});
    } else {
      await this.changeOrganisationAsync({ orgId: organisationId, forceRender: false });
      await this.changeProjectAsync({projectId, forceRender: false});
    }
    this.loadingDetails = false;
  }

  private async goToGatewayDetails(organisationId: string, projectId: number, id: number) {
    this.loadingDetails = true;
    if (this.activeOrganisation === organisationId) {
      await this.changeProjectAsync({projectId, forceRender: false});
    } else {
      await this.changeOrganisationAsync({ orgId: organisationId, forceRender: false });
      await this.changeProjectAsync({projectId, forceRender: false});
    }
    this.loadingDetails = false;
  }

  @Watch('equipmentFilters')
  private onEquipmentFiltersChange() {
    if (this.equipmentFilters) {
      this.loadMapMarkers(false);
    }
  }


  @Watch('chartToastVisible')
  private onToastVisibleChange(isVisible: boolean) {
    if (!isVisible) {
      this.chartToastData = {};
    }
  }

  @Watch('visibleMarkers', { deep: true })
  private onVisibleMarkersChange() {
    this.debounceLayerUpdate(false);
    this.updateSelectedLocations();
  }

  private async fetchConnectionDetails(connections: any[]) {
    if (this.activePanel === null) {
      return;
    }
    if (!connections || connections.length === 0) {
      Vue.set(this.selectedLocations[this.activePanel], 'details', []);
      return;
    }

    this.loadingConnectionDetails = true;
    try {
      const isDeviceActive = this.selectedLocations[this.activePanel].type === 'device';
      let details: any[] = [];

      if (isDeviceActive) {
        const primaryStatusMap = new Map <string, boolean> ();
        connections.forEach((c) => {
          const identifier = this.getGatewayIdentifier(c);
          if (identifier) {
            primaryStatusMap.set(identifier, c.is_primary || false);
          }
        });

        const gatewayIdentifiers: string[] = [];
        const stationMap = new Map<string, string>();
        const ghostGateways: any[] = [];
        for (const conn of connections) {
          const identifier = this.getGatewayIdentifier(conn);
          const eui = identifier ? this.getGatewayEui(conn) : null;
          if (eui) {
            gatewayIdentifiers.push(eui);
            stationMap.set(eui, conn.stationName || conn.station_name || '');
          } else {
            ghostGateways.push({
              id: null,
              gatewayEui: conn.gatewayEui || conn.gateway_eui,
              stationName: conn.stationName || conn.station_name,
              status: 'unknown',
              type: 'gateway',
              is_in_scope: false,
              organisationId: null,
              organisationName: null,
              projectName: null,
              locationName: null,
              siteName: null,
              typeImage: null,
              lat: null,
              lng: null,
              isPrimary: identifier ? primaryStatusMap.get(identifier) || false : false,
            });
          }
        }

        let detailedItemsFromApi: any[] = [];
        if (gatewayIdentifiers.length > 0) {
          detailedItemsFromApi = await WidgetService.getBatchDetails({ deviceIds: [], gatewayIdentifiers });
        }

        const obtainedEuis: string[] = [];
        details = detailedItemsFromApi.map((item) => {
          const identifier = this.getGatewayIdentifier(item);
          item.gatewayEui = item.gatewayEui.toUpperCase();
          obtainedEuis.push(item.gatewayEui);
          return {
            ...item,
            isPrimary: identifier ? primaryStatusMap.get(identifier) || false : false,
          };
        });

        const missingEuis = gatewayIdentifiers.filter((eui) => !obtainedEuis.includes(eui));
        if (missingEuis.length > 0) {
          missingEuis.forEach((eui) => {
            const stationName = stationMap.get(eui) || '';
            ghostGateways.push({
              id: null,
              gatewayEui: eui,
              stationName,
              status: 'unknown',
              type: 'gateway',
              is_in_scope: false,
              organisationId: null,
              organisationName: null,
              projectName: null,
              locationName: null,
              siteName: null,
              typeImage: null,
              lat: null,
              lng: null,
              isPrimary: primaryStatusMap.get(eui) || false,
            });
          });
        }

        if (ghostGateways.length > 0) {
          details = details.concat(ghostGateways);
        }

      } else {
        const deviceIds = connections.map((conn) => conn.device_id);
        if (deviceIds.length > 0) {
          details = await WidgetService.getBatchDetails({ deviceIds, gatewayIdentifiers: [] });
        }
      }

      if (this.selectedLocations[this.activePanel]) {
        Vue.set(this.selectedLocations[this.activePanel], 'details', details.sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)) || []);
      }
      await this.$nextTick();

    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.loadingConnectionDetails = false;
    }
  }

  @Watch('statusFilters', { deep: true })
  private onStatusFiltersChange() {
    this.debounceLayerUpdate(false);
    this.updateSelectedLocations();
  }

  @Watch('drawerVisible')
  private async onDrawerVisibleChange(isVisible: boolean) {
    if (isVisible) {
      if (this.isFilteredViewActive && this.activePanel !== null) {
        const currentPanel = this.activePanel;
        this.activePanel = null;
        await this.$nextTick();
        this.activePanel = currentPanel;
      }
    } else {
      this.restackMarker();
      this.chartToastVisible = false;
      this.historyVisible = false;
      this.dailyCharts = [];
      this.chartsExpanded = false;

      if (!this.isFilteredViewActive) {
        this.resetHistoricalViewState();
        this.resetSelectedMarkerStyle();
        this.selectedLocations = [];
        this.activePanel = null;
        this.selectedMarker = null;
        this.generateLegendSVGs();
      }
    }
  }

  private startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  private stopDrag() {
    this.isDragging = false;
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }

  private handleDrag(event: MouseEvent) {
    if (!this.isDragging || !this.$refs.sliderContainer) {
      return;
    }

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }

    const container = (this.$refs.sliderContainer as any).$el as HTMLElement;
    const bounds = container.getBoundingClientRect();
    const scrollAmount = 30;

    if (event.clientX > bounds.right) {
      this.scrollInterval = window.setInterval(() => {
        container.scrollLeft += scrollAmount;
      }, 50);
    } else if (event.clientX < bounds.left) {
      this.scrollInterval = window.setInterval(() => {
        container.scrollLeft -= scrollAmount;
      }, 50);
    }
  }

  @Watch('timelineValue')
  private onTimelineValueChange(newIndex: number) {
    if (newIndex >= this.historyDays.length) {
      this.$nextTick(() => {
        this.timelineValue = this.historyDays.length - 1;
      });
    }
  }

  private onSliderEnd(dayIndex: number) {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
    this.stopDrag();

    const isLatestDay = dayIndex === this.historyDays.length - 1;
    if (isLatestDay && this.activePanel) {
      const selected = this.selectedLocations[this.activePanel];
      if (selected) {
        if (selected.network) {
          Vue.set(selected, 'displayNetwork', { ...selected.network });
        }
        const originalLocation = { lat: selected.lat, lng: selected.lng };
        Vue.set(selected, 'displayLocation', originalLocation);
        this.restackMarker();
      }
      this.fetchDataForDate(undefined);
    } else {
      const selectedDate = this.historyDays[dayIndex];
      this.fetchDataForDate(selectedDate);
    }
  }

  private async fetchDataForDate(date?: string) {
    if (this.activePanel === null) { return; }
    GlobalTokenManager.cancel();
    this.loadingConnectionDetails = true;
    this.resetHistoricalViewState();

    try {
      const selected = this.selectedLocations[this.activePanel];
      const queryParams = selected.type === 'device'
          ? { deviceId: selected.id, date }
          : { gatewayId: selected.id, date };

      const connectionsData = await WidgetService.getConnections(queryParams);
      const dailyConnections = connectionsData.history.length ? connectionsData.history[0].connections : [];

      if (date && dailyConnections.length > 0) {
        const targetConnection = dailyConnections.find((conn: any) => conn.is_primary) || dailyConnections[0];

        const historicalNetworkData = {
          rssi: targetConnection.avg_rssi,
          snr: targetConnection.avg_snr,
          loraSpreadingFactor: targetConnection.lora_spreading_factor,
        };
        Vue.set(selected, 'displayNetwork', historicalNetworkData);

        if (targetConnection.self_lat && targetConnection.self_lng) {
          const historicalLocation = { lat: targetConnection.self_lat, lng: targetConnection.self_lng };
          Vue.set(selected, 'displayLocation', historicalLocation);

          const hasMoved = Math.abs(historicalLocation.lat - selected.lat) > 0.00001 ||
              Math.abs(historicalLocation.lng - selected.lng) > 0.00001;

          const isStacked = this.selectedMarker && this.selectedMarker.locationData.length > 1;

          if (isStacked) {
            if (hasMoved) {
              if (!this.detachedMarker) {
                this.detachMarker(selected, historicalLocation);
              } else {
                this.detachedMarker.position = historicalLocation;
              }
            } else {
              this.restackMarker();
            }
          } else if (this.selectedMarker) {
            this.selectedMarker.position = hasMoved ? historicalLocation : { lat: Number(selected.lat), lng: Number(selected.lng) };
          }
        } else {
          const originalLocation = { lat: selected.lat, lng: selected.lng };
          Vue.set(selected, 'displayLocation', originalLocation);
          this.restackMarker();
          if (this.selectedMarker) {
            this.selectedMarker.position = { lat: Number(selected.lat), lng: Number(selected.lng) };
          }
        }
      } else if (this.selectedMarker) {
        this.restackMarker();
        this.selectedMarker.position = { lat: Number(selected.lat), lng: Number(selected.lng) };
        if (!date) {
          if (selected.network) {
            Vue.set(selected, 'displayNetwork', { ...selected.network });
          } else {
            Vue.set(selected, 'displayNetwork', { rssi: null, snr: null, loraSpreadingFactor: null });
          }
        } else {
          const historicalNetworkData = {
            rssi: null,
            snr: null,
            loraSpreadingFactor: null,
          };
          Vue.set(selected, 'displayNetwork', historicalNetworkData);
        }
      }

      Vue.set(selected, 'connections', dailyConnections);
      const startPointLat = (selected.displayLocation && selected.displayLocation.lat) || selected.lat;
      const startPointLng = (selected.displayLocation && selected.displayLocation.lng) || selected.lng;
      const startPoint = { lat: Number(startPointLat), lng: Number(startPointLng) };

      this.updateMapForHistoricalView(selected, dailyConnections);
      this.drawConnectionGraph(dailyConnections, startPoint, selected.type);
      return await this.fetchConnectionDetails(dailyConnections);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.loadingConnectionDetails = false;
    }
  }

  private detachMarker(selectedItem: any, location: { lat: number, lng: number }): void {
    if (!this.selectedMarker) { return; }

    this.originalStackState = { marker: this.selectedMarker, content: this.selectedMarker.content };

    let detachedMarkerContent;
    let remainingStackContent;

    if (selectedItem.type === 'device') {
      const statusColor = MarkerFactory.getDeviceStatusColor(selectedItem.status);
      const sfColor = MarkerFactory.getSpreadingFactorColor(selectedItem.displayNetwork.loraSpreadingFactor);
      detachedMarkerContent = MarkerFactory.createDeviceMarkerSVG(statusColor, sfColor);

      const remainingItems = this.selectedMarker.locationData.filter((d: any) => d.id !== selectedItem.id);
      remainingStackContent = MarkerFactory.createStackedDeviceMarkerSVG(remainingItems);
    } else {
      const statusColor = MarkerFactory.getGatewayStatusColor(selectedItem.status);
      detachedMarkerContent = MarkerFactory.createGatewayIcon(statusColor);

      const remainingItems = this.selectedMarker.locationData.filter((g: any) => this.getGatewayIdentifier(g) !== this.getGatewayIdentifier(selectedItem));
      remainingStackContent = MarkerFactory.createStackedGatewayMarkerSVG(remainingItems);
    }

    this.detachedMarker = new this.AdvancedMarkerElement({
      map: this.map,
      position: location,
      content: detachedMarkerContent,
      zIndex: 1001,
    });

    this.selectedMarker.content = remainingStackContent;
  }

  private restackMarker() {
    if (this.detachedMarker) {
      this.detachedMarker.map = null;
      this.detachedMarker = null;

      if (this.originalStackState) {
        this.originalStackState.marker.content = this.originalStackState.content;
        this.originalStackState = null;
      }
    }
  }

  @Watch('activePanel')
  private async onActivePanelChange(newIndex?: number | null) {
    this.timelineKey++;
    this.dailyCharts = [];
    GlobalTokenManager.cancel();
    if (newIndex === null || newIndex === undefined) {
      this.resetHistoricalViewState();
      this.historyVisible = false;
      return;
    }
    this.generateLegendSVGs();

    const selected = this.selectedLocations[newIndex];
    if (!selected) {
      return;
    }

    if (this.selectedMarker) {
      const locationData = (this.selectedMarker as any).locationData || [];
      const itemCountAtLocation = locationData.length;

      const hasDevices = locationData.some((item: any) => item.type === 'device');
      const hasGateways = locationData.some((item: any) => item.type === 'gateway');

      let newSVG;
      if (hasDevices && hasGateways) {
        newSVG = MarkerFactory.createCombinedMarkerSVG(locationData, selected);
      } else if (hasDevices) {
        if (itemCountAtLocation > 1) {
          newSVG = MarkerFactory.createStackedDeviceMarkerSVG(locationData, selected);
        } else {
          const statusColor = MarkerFactory.getDeviceStatusColor(selected.status);
          const sfColor = MarkerFactory.getSpreadingFactorColor(selected.network.loraSpreadingFactor);
          newSVG = MarkerFactory.createDeviceMarkerSVG(statusColor, sfColor);
        }
      } else if (hasGateways) {
        if (itemCountAtLocation > 1) {
          newSVG = MarkerFactory.createStackedGatewayMarkerSVG(locationData, selected);
        } else {
          const statusColor = MarkerFactory.getGatewayStatusColor(selected.status);
          newSVG = MarkerFactory.createGatewayMarkerSVG(statusColor);
        }
      }

      if (newSVG) {
        this.selectedMarker.content = newSVG;
      }
    }

    this.layersLoading = true;
    this.loadingConnectionDetails = true;

    this.historyVisible = false;
    this.connectionHistory = [];
    this.historyDays = [];

    try {
      const queryParams = selected.type === 'device'
          ? { deviceId: selected.id }
          : { gatewayId: selected.id };

      if (selected.bearer !== 'lora' && selected.type !== 'gateway') {
        return;
      }
      const datesResponse = await WidgetService.getHistoryDates(queryParams);
      this.historyDays = datesResponse.dates || [];
      if (this.historyDays.length > 1) {
        this.chartsLoading = true;
        this.timelineLoading = true;

        this.historyVisible = true;
        this.timelineValue = this.historyDays.length - 1;
        if (selected.type === 'device') {
          const startDate = this.historyDays[0];
          const endDate = this.historyDays[this.timelineValue];
          this.allDailyData = await WidgetService.getDeviceTimelineData(selected.id, startDate, endDate);
        }
        this.$nextTick(async () => {
          try {
            if (selected.type === 'device') {
              this.populateTimelineChart();
            }
          } catch (e) {
            this.dailyCharts = [];
          } finally {
            setTimeout(() => {
              this.chartsLoading = false;
              this.timelineLoading = false;
            }, 300);
          }
          this.onSliderEnd(this.timelineValue);
          const container = (this.$refs.sliderContainer as any).$el as HTMLElement;
          if (container) {
            container.scrollLeft = container.scrollWidth;
          }
        });
      } else {
        this.historyVisible = false;
        await this.fetchDataForDate(undefined);
      }
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.layersLoading = false;
      this.loadingConnectionDetails = false;
    }

    this.$nextTick(() => {
      const container = this.$refs.detailsPanel as HTMLElement;
      if (!container) { return; }

      const headers = container.querySelectorAll('.v-expansion-panel-header');

      const targetHeader = headers[newIndex];

      if (targetHeader && newIndex !== 0) {
        targetHeader.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  }

  @Watch('globalSearchQuery')
  private onSearchQueryChanged(val: string) {
    if (this.selectedSearchItem && val === this.selectedSearchItem.name) {
      return;
    }
    if (val && !this.selectedSearchItem) {
      this.debouncedSearch();
    }
  }

  @Watch('selectedSearchItem')
  private async onSearchItemSelected(item: any) {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = null;
    }
    if (!item) {
      return;
    }

    this.resetHistoricalViewState();
    this.closePanel();

    if (item.type === 'place' || item.type === 'location') {
      this.searchLoading = true;
      if (item.type === 'place') {
        this.geocoder.geocode({placeId: item.id}, (results: any, status: any) => {
          this.searchLoading = false;
          if (status === 'OK' && results[0]) {
            const loc = results[0];
            this.placesMarker = new this.AdvancedMarkerElement({
              position: loc.geometry.location,
              map: this.map,
              title: item.name,
            });
            if (loc.geometry.viewport) {
              this.map.fitBounds(loc.geometry.viewport);
              this.map.setZoom(12);
            } else {
              this.map.setCenter(loc.geometry.location);
              this.map.setZoom(12);
            }
            this.globalSearchQuery = item.name;
          } else {
            this.addToastErrorMessage(`Failed to find location: ${status}`);
          }
        });
      } else {
        this.placesMarker = new this.AdvancedMarkerElement({
          position: {lat: item.position[0], lng: item.position[1]},
          map: this.map,
          title: item.name,
        });
        this.map.setCenter({lat: item.position[0], lng: item.position[1]});
        this.map.setZoom(12);
        this.globalSearchQuery = item.name;
        await this.loadMapMarkers(false);
      }
    } else {
      this.clearPlacesMarker();

      if (item.type === 'device') {
        this.filters = { deviceId: item.id.toString() };
      } else if (item.type === 'gateway') {
        this.filters = { gatewayId: item.id.toString() };
      }
      await this.loadMapMarkers(false);

      await this.findAndClickMarker(item);
    }

    this.$nextTick(() => {
      this.globalSearchQuery = item.name;
      this.searchLoading = false;
    });
  }

  private drawConnectionGraph(connections: any[], startPoint: any, activeItemType: string) {
    const strongLineOptions = { strokeColor: '#1976D2', strokeOpacity: 0.9, strokeWeight: 4 };
    const lightLineOptions = { strokeColor: '#1976D2', strokeOpacity: 0.1, strokeWeight: 2, icons: [{ icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 3 }, offset: '0', repeat: '15px' }]};

    let unknownLocationIndex = 0;
    const totalUnknownLocations = connections.filter((c) => c.lat === null).length;

    for (const connection of connections) {
      let endPoint;
      const hasUnknownLocation = connection.lat === null || connection.lng === null;

      if (activeItemType === 'device') {
        if (hasUnknownLocation) {
          const latOffset = this.getOffsetForZoomLevel();
          const lngSpread = this.getOffsetForZoomLevel();

          if (totalUnknownLocations === 1) {
            endPoint = {lat: startPoint.lat - latOffset, lng: startPoint.lng};
          } else {
            const initialLngOffset = (totalUnknownLocations - 1) * lngSpread / 2;
            endPoint = {
              lat: startPoint.lat - latOffset,
              lng: (startPoint.lng - initialLngOffset) + (unknownLocationIndex * lngSpread),
            };
          }
          unknownLocationIndex++;

        } else {
          endPoint = {lat: Number(connection.lat), lng: Number(connection.lng)};
        }

        if (!connection.is_in_scope || hasUnknownLocation) {
          const identifier = this.getGatewayIdentifier(connection);
          const ghostMarker = new this.AdvancedMarkerElement({
            map: this.map,
            position: endPoint,
            content: MarkerFactory.createGatewayIcon('#616161', 1),
            title: `Gateway ${identifier || 'Unknown'} (${hasUnknownLocation ? 'Location Unknown' : 'Out of Scope'})`,
            zIndex: 900,
          });
          (ghostMarker as any).identifier = identifier;
          this.ghostMarkers.push(ghostMarker);
        }
      } else {
        endPoint = { lat: Number(connection.lat), lng: Number(connection.lng) };
      }

      const polyline = new google.maps.Polyline({
        path: [startPoint, endPoint],
        ...(connection.is_primary ? strongLineOptions : lightLineOptions),
      });
      polyline.setMap(this.map);
      this.activePolylines.push(polyline);
    }
  }

  private resetHistoricalViewState(): void {
    this.restackMarker();

    this.hiddenOriginalMarkers.forEach((marker) => marker.map = this.map);
    this.hiddenOriginalMarkers = [];

    this.ghostMarkers.forEach((marker) => marker.map = null);
    this.ghostMarkers = [];
    this.activePolylines.forEach((line) => line.setMap(null));
    this.activePolylines = [];

    if (!this.drawerVisible) {
      this.allDeviceMarkers.forEach((marker) => {
        if (marker.content) {
          marker.content.style.opacity = '1';
          marker.zIndex = null;
        }
      });
      Object.values(this.gatewayMarkers).forEach((marker) => {
        if (marker.content) {
          marker.content.style.opacity = '1';
          marker.zIndex = null;
        }
      });
    }
  }

  private getGatewayEui(connection: any): string | null {
    const eui = connection.gatewayEui || connection.gateway_eui;
    if (eui && eui.length) {
      return String(eui).toUpperCase();
    }
    return null;
  }

  private getGatewayIdentifier(connection: any): string {
    const eui = connection.gatewayEui || connection.gateway_eui;
    if (eui) {
      return String(eui).toUpperCase();
    }

    const stationName = connection.stationName || connection.station_name;
    if (stationName) {
      return stationName;
    }
    return '';
  }

  private updateSelectedLocations() {
    if (!this.selectedMarker) {
      return;
    }

    let filteredLocations = [...this.unfilteredSelectedLocations];

    filteredLocations = filteredLocations.filter((loc) => {
      return this.visibleMarkers.includes(loc.type + 's');
    });


    filteredLocations = filteredLocations.filter((loc) => {
      return this.statusFilters.includes(loc.status);
    });

    if (this.orgFilter) {
      filteredLocations = filteredLocations.filter((loc) => {
        return loc.organisationId === this.orgFilter;
      });
    }

    if (this.projectFilter) {
      filteredLocations = filteredLocations.filter((loc) => {
        return loc.projectId === this.projectFilter;
      });
    }

    this.selectedLocations = filteredLocations;

    if (this.selectedLocations.length === 0) {
      this.activePanel = null;
    } else {
      if (this.activeItem) {
        const stillInList = this.selectedLocations.some((loc) => {
          const locId = loc.type === 'device' ? loc.id : this.getGatewayIdentifier(loc);
          const currentId = this.activeItem.type === 'device' ? this.activeItem.id : this.getGatewayIdentifier(this.activeItem);
          return locId === currentId;
        });

        if (!stillInList) {
          this.$nextTick(() => {
            this.activePanel = 0;
          });
        }
      } else {
        this.$nextTick(() => {
          this.activePanel = 0;
        });
      }
    }
  }

  private get isFilteredViewActive(): boolean {
    return this.equipmentFilters.length > 0;
  }

  private get refreshFabStyle() {
    const right = this.drawerVisible ? '366px' : '76px';
    return {
      top: '32px',
      right,
      transition: 'right 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
      zIndex: 15,
    };
  }

  private async refreshMapData() {
    if (this.selectedMarker) {
      return;
    }
    this.layersLoading = true;
    try {
      await this.loadMapMarkers(false);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(`Failed to refresh map data: ${err.message}`);
    } finally {
      this.layersLoading = false;
    }
  }

  private startAutoRefresh() {
    this.stopAutoRefresh();
    const tenMinutesInMs = 10 * 60 * 1000;
    this.refreshInterval = window.setInterval(() => {
      if (this.autoRefreshEnabled) {
        this.refreshMapData();
      }
    }, tenMinutesInMs);
  }

  private stopAutoRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  private async forceRefresh() {
    if (this.selectedMarker) {
      return;
    }
    await this.refreshMapData();
  }

  private toggleAutoRefresh() {
    this.autoRefreshEnabled = !this.autoRefreshEnabled;
  }

  private getOffsetForZoomLevel(): number {
    if (!this.map) { return 0.02; }
    const zoom = this.map.getZoom();

    switch (zoom) {
      case 0:
      case 1:
      case 2:
        return 20.8; // World view
      case 3:
        return 10.4;
      case 4:
        return 5.2;
      case 5:
        return 2.6;
      case 6:
        return 1.8;  // Country view
      case 7:
        return 0.92;
      case 8:
        return 0.48;  // Region view
      case 9:
        return 0.24;
      case 10:
        return 0.12; // Metro area view
      case 11:
        return 0.064;
      case 12:
        return 0.032; // City view
      case 13:
        return 0.016;
      case 14:
        return 0.008; // Neighborhood view
      case 15:
        return 0.004;
      case 16:
        return 0.002; // Street view
      case 17:
        return 0.001;
      default:
        return 0.001; // Detailed view
    }
  }

  private beforeDestroy() {
    this.showJiraWidget();
    if (this.widgetFinderInterval) {
      clearInterval(this.widgetFinderInterval);
    }
    this.stopAutoRefresh();

    const footerEl = (this.$refs.timelineFooter as any) ? (this.$refs.timelineFooter as any).$el : undefined;
    if (footerEl) {
      footerEl.removeEventListener('mousedown', this.startDrag);
    }
    window.removeEventListener('mouseup', this.stopDrag);
    window.removeEventListener('mousemove', this.handleDrag);
    document.documentElement.removeEventListener('mouseleave', this.stopDrag);

    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  }

  private get autoRefreshColor(): string {
    return this.autoRefreshEnabled ? 'success' : 'grey darken-1';
  }

  private get autoRefreshIcon(): string {
    return this.autoRefreshEnabled ? 'mdi-sync' : 'mdi-sync-off';
  }
}
